import { Link, useLocation, matchPath } from 'react-router-dom'
import Header from '../components/Header'

// If changes, be sure to copy to Layout.js

const Error = () => {
  const location = useLocation()

  const hideNavBarRoutes = [
    '/', 
    '/questionnaire', 
    // '/prompts', 
    '/prompt/:promptId/canvas', 
    '/prompt/:promptId/chat', 
    '/chathistory', 
    // '/artwork/:art_id', 
    '/artwork'
  ]
  const shouldShowNav = !hideNavBarRoutes.some(pattern => (
    matchPath({ path: pattern, end: true }, location.pathname)
  ))

  return (
    <div id="flex-layout">
        <Header shouldShowNav={shouldShowNav} />
        <main id="outlet-layout" className={shouldShowNav ? 'bottom-nav' : ''}>
            <div className='container'>
                <h2>Uh oh! This part of the canvas is still blank.</h2>
                <p>You might be coloring outside the lines - or maybe this page doesn’t exist.</p>
                <p>Let’s get you back on track!</p>
                <Link to="/">Back Home</Link>
            </div>
        </main>
    </div>
  )
}

export default Error